"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _qrcode = _interopRequireDefault(require("qrcode.react"));

var _semanticUiReact = require("semantic-ui-react");

var _moment = _interopRequireDefault(require("../../lib/moment"));

var _Element = _interopRequireDefault(require("../01_atoms/Element"));

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _SquaredText = _interopRequireDefault(require("../01_atoms/SquaredText"));

var _Icon = _interopRequireDefault(require("../01_atoms/Icon"));

var _HighligthedText = _interopRequireDefault(require("../01_atoms/HighligthedText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BoardingPass = function BoardingPass(_ref) {
  var ticket = _ref.ticket,
      passengerIndex = _ref.passengerIndex,
      t = _ref.t,
      backgroundColor = _ref.backgroundColor,
      qrCodeData = _ref.qrCodeData;
  // FIXME: Add passengers
  var passenger = ticket.ticketDetails.passengers[passengerIndex];
  var firstName = passenger.firstName,
      lastName = passenger.lastName,
      seat = passenger.seat,
      ssn = passenger.ssn;

  var KeyValue = function KeyValue(_ref2) {
    var name = _ref2.name,
        value = _ref2.value;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        fontWeight: 'bold'
      }
    }, name), /*#__PURE__*/_react["default"].createElement("div", null, value));
  };

  var ticketDetails = ticket.ticketDetails;
  var departure = (0, _moment["default"])(ticketDetails.departureTime);
  var arrival = (0, _moment["default"])(ticketDetails.arrivalTime); // const rideDuration = moment.duration(arrival.diff(departure));
  // const formattedDuration = `${rideDuration.hours()}h ${rideDuration.minutes()}m`;

  var nDaysAdded = _moment["default"].duration((0, _moment["default"])(arrival.format('YYYY-MM-DD')).diff((0, _moment["default"])(departure.format('YYYY-MM-DD')))).days();

  var d = nDaysAdded ? " (+".concat(nDaysAdded, "d)") : '';
  var dh = departure.format('HH:mm');
  var ah = arrival.format('HH:mm');
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    backgroundColor: backgroundColor,
    style: {
      maxWidth: 500,
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    title: null
    /* `Here your ticket for ${passenger.firstName}` */

  }, /*#__PURE__*/_react["default"].createElement(_Element["default"], {
    style: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    src: ticket.ticketDetails.transporter.logo,
    width: 50,
    style: {
      marginRight: 20
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontWeight: 'bold',
      fontSize: '1rem'
    }
  }, ticket.ticketDetails.transporter.name)), /*#__PURE__*/_react["default"].createElement(_Element["default"], {
    style: {
      textAlign: 'center'
    }
  }, departure.format('LL')), /*#__PURE__*/_react["default"].createElement(_Element["default"], {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '40%'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: 10,
      fontWeight: 'bold'
    }
  }, ticket.ticketDetails.originTerminal.name), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold',
      fontSize: '12px'
    }
  }, t('Departing')), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'normal',
      fontSize: '10px'
    }
  }, dh))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '20%',
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "arrow alternate circle right outline",
    style: {
      color: 'gray',
      fontSize: '3rem'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '40%',
      textAlign: 'right'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: 10,
      fontWeight: 'bold'
    }
  }, ticket.ticketDetails.destinationTerminal.name), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold',
      fontSize: '12px'
    }
  }, t('Arriving')), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'normal',
      fontSize: '10px'
    }
  }, "".concat(ah).concat(d))))), /*#__PURE__*/_react["default"].createElement(_Element["default"], null, /*#__PURE__*/_react["default"].createElement(KeyValue, {
    name: t('First name'),
    value: /*#__PURE__*/_react["default"].createElement(_HighligthedText["default"], null, firstName)
  }), /*#__PURE__*/_react["default"].createElement(KeyValue, {
    name: t('Last name'),
    value: lastName
  }), /*#__PURE__*/_react["default"].createElement(KeyValue, {
    name: t('Cedula'),
    value: ssn || '1234567890'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: 20
    }
  }), /*#__PURE__*/_react["default"].createElement(KeyValue, {
    name: t('Seat'),
    value: /*#__PURE__*/_react["default"].createElement(_SquaredText["default"], {
      style: {
        width: 24,
        height: 24
      }
    }, seat)
  })), /*#__PURE__*/_react["default"].createElement(_Element["default"], {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_qrcode["default"], {
    value: qrCodeData,
    size: 90
  }), /*#__PURE__*/_react["default"].createElement("pre", null, ticket.id.toUpperCase()))));
};

var _default = BoardingPass;
exports["default"] = _default;